var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedfarRx(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.01 21.259l4.29-6.46h-3.9l-2.71 4.13-3.493-5.184a6.89 6.89 0 001.579-1.003c.485-.409.88-.909 1.178-1.5.299-.592.448-1.28.448-2.069 0-1.166-.248-2.129-.744-2.894-.495-.765-1.252-1.333-2.267-1.711C14.373 4.19 13.082 4 11.518 4H6.5v17.265h3.653V14.64h1.945l4.114 6.626L11.782 28h4.077l2.78-4.524L21.41 28H25.5l-4.49-6.741zm-9.68-9.596h-1.177V7h1.107c1.178 0 2.05.173 2.61.52.56.347.842.929.842 1.749 0 .82-.261 1.384-.784 1.789s-1.389.609-2.6.609l.003-.004z"
  })));
}
export default SvgMedfarRx;